module.exports = __webpack_public_path__ + "assets/49.jpg?51a3470387263a30e35e4414eef1f7d4";